export function joinPath(...parts) {
    return parts.map((part) => part.toString().replace(/^\/|\/$/g, '')).join('/');
}
